import type { SVGProps } from "react";
export interface AppleFoodIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function AppleFoodIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: AppleFoodIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M4.375 11.998c0-1.596.41-2.7.905-3.397l.151-.198q.078-.095.16-.18L6.404 9l.814.777q-.046.048-.104.127c-.181.256-.489.885-.489 2.094 0 .493.072 1.102.218 1.757a1.125 1.125 0 1 1-2.196.49 10.6 10.6 0 0 1-.272-2.248Zm1.216-3.775a1.125 1.125 0 0 1 1.627 1.554zM10.874 6v-.764c0-.886-.468-1.7-1.223-2.146l-.153-.084-.102-.057a1.125 1.125 0 0 1 1.001-2l.105.045.295.16a4.74 4.74 0 0 1 2.327 4.082V6a1.125 1.125 0 0 1-2.25 0"
      />
      <path
        fill={color}
        d="M20.875 11.998c0-3.612-1.815-5.448-3.648-5.794-.98-.185-1.626-.021-2.32.226-.693.246-1.661.69-2.906.69s-2.216-.444-2.908-.69c-.695-.247-1.34-.411-2.32-.226-1.833.346-3.648 2.183-3.648 5.794 0 1.805.574 4.125 1.556 5.973 1.025 1.93 2.238 2.903 3.319 2.903.503 0 .937-.16 1.582-.418.605-.242 1.422-.582 2.418-.582s1.813.34 2.418.582c.645.258 1.079.418 1.582.418 1.08 0 2.294-.973 3.319-2.903.981-1.848 1.555-4.168 1.556-5.973m2.25 0c0 2.195-.675 4.877-1.818 7.03-1.1 2.07-2.888 4.096-5.307 4.096-.997 0-1.813-.338-2.418-.58-.645-.258-1.079-.42-1.582-.42s-.936.162-1.582.42c-.604.242-1.421.58-2.418.58-2.42 0-4.206-2.026-5.306-4.097-1.143-2.152-1.819-4.834-1.819-7.03 0-4.39 2.314-7.406 5.481-8.003 1.519-.287 2.592-.003 3.49.316.9.32 1.4.56 2.155.56.753 0 1.253-.24 2.153-.56.898-.32 1.972-.603 3.49-.316 3.167.597 5.48 3.612 5.48 8.003Z"
      />
    </svg>
  );
}
